<template>
  <component :is="currentRoute"></component>
</template>

<script>
import Login from '../layouts/Login.vue';
import Dashboard from '../layouts/Dashboard.vue';

const routes = {
  '/': Login,
  '/dashboard': Dashboard,
};

export default {
  data() {
    return {
      current: window.location.pathname,
      default: Login,
    };
  },
  computed: {
    currentRoute() {
      return routes[this.current] || this.default;
    },
  },
};
</script>
